import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

export interface CONFIGDATA {
  [key: string]: any;
}

@Injectable({
    providedIn: 'root'
  })
export class ConfigService {
    protected static vars: any = {};
    constructor(private http: HttpClient) {
    }

    async resolve(url: string): Promise<CONFIGDATA> {
      const response = await this.http.get(url).toPromise();
      ConfigService.vars = Object.assign({}, ConfigService.vars, response);
      return response;
    }

    get(key: string) {
        return ConfigService.vars[key];
    }
    getString(key: string): string {
      if (ConfigService.vars[key]) {
          return <string>ConfigService.vars[key];
      }
      return '';
    }
    set(key: string, value: any) {
        ConfigService.vars[key] = value;
    }
}
